import Component from 'components/pages/BrowserApp/BrowserApp';
import { buildPage } from 'utils/pageHelper';
export default buildPage(Component, {
  requiresAuthentication: true,
  metaData: {
    title: 'Search',
    description: 'Earn money with our browser app.',
  },
});
